import React from "react"
import { Container, Row, Col } from "react-bootstrap"

import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

export default function Shop() {
  return (
    <section className="shop-section section-padding">
      <Container>
        <Row>
          <Col>
            <div className="shop-content text-center text-white">
              <h3 className="section-subtitle mb-5">
                20% OF SALES GO TO THE FLUO FOUNDATION
              </h3>
              <h2 className="section-title mb-6">Shop To Support</h2>
              <Row className="d-flex align-items-center justify-content-center">
                <Col lg="4" md="12" className="my-4">
                  <div className="product-item">
                    <div className="productitem mb-5">
                      <Link to="/shop/echo-greetings/">
                        <StaticImage
                          className="img-fluid"
                          src="../../images/cards.png"
                          alt="Card"
                        />
                      </Link>
                    </div>
                    <Link
                      to="/shop/echo-greetings/"
                      className="cta-2 text-uppercase"
                    >
                      Shop<span className="d-block">Echo Greetings</span>
                    </Link>
                  </div>
                </Col>
                <Col lg="4" md="12" className="my-4">
                  <div className="product-item">
                    <div className="productitem mb-5">
                      <Link to="/shop/stainless-steel-water-bottles/">
                        <StaticImage
                          className="img-fluid"
                          src="../../images/bottle.png"
                          alt="Bottle"
                        />
                      </Link>
                    </div>
                    <Link
                      to="/shop/stainless-steel-water-bottles/"
                      className="cta-2 text-uppercase"
                    >
                      Shop
                      <span className="d-block">Water Bottles</span>
                    </Link>
                  </div>
                </Col>
                <Col lg="4" md="12" className="my-4">
                  <div className="product-item">
                    <div className="productitem mb-5">
                      <Link to="/shop/sticker/">
                        <StaticImage
                          className="img-fluid"
                          src="../../images/sticker.png"
                          alt="Sticker"
                        />
                      </Link>
                    </div>
                    <Link to="/shop/sticker/" className="cta-2 text-uppercase">
                      Shop<span className="d-block">Fluo Sticker</span>
                    </Link>
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
